<div class="w-100 text-center bg-transparent">
  <fa-icon
    class="loader loader--center medium"
    icon="spinner"
    animation="spin"
  ></fa-icon>
</div>
